module.exports = __webpack_public_path__ + "img/70.9b525dc7.png";